module.exports = __webpack_public_path__ + "img/vieja_tiuque.083ff0e1.jpg";